import Vue from 'vue';
import Router from 'vue-router';
import Starter from './pages/StarterPage.vue';
import StarterNavbar from './layout/StarterNavbar.vue';
import StarterFooter from './layout/StarterFooter.vue';

import indexHome from "@/index/indexHome";
import indexTask from "@/index/indexTask";
import indexLeader from "@/index/indexLeader";
import indexLogin from "@/index/indexLogin";
import indexRegist from "@/index/indexRegist";
import indexOrganization from "@/index/indexOrganization";
import indexConsole from "@/index/indexConsole";
import indexWorkshop from "@/index/indexWorkshop";

Vue.use(Router);

const router =  new Router({
    routes: [
        {
            path: '/',
            component: Starter,
            props: {
                header: {colorOnScroll: 400},
                footer: {backgroundColor: 'black'}
            },
            children: [
                {path: '', name: 'indexHome', component: indexHome},
                {path: 'task', name: 'indexTask', component: indexTask},
                {path: 'leaderboard', name: 'indexLeader', component: indexLeader},
                {path: 'login', name: 'indexLogin', component: indexLogin},
                {path: 'regist', name: 'indexRegist', component: indexRegist},
                {path: 'workshop', name: 'indexWorkshop', component: indexWorkshop},
                {path: 'organization', name: 'indexOrganization', component: indexOrganization},
                {path: 'console', name: 'indexConsole', component: indexConsole, meta: {requireAuth: true}},
            ]
        }
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return {selector: to.hash};
        } else {
            return {x: 0, y: 0};
        }
    },
    mode: 'history',
    base:'/sharedtask/social22/',
});

router.beforeEach((to, from, next) => {
  // 判断该路由是否需要登录权限
  if (to.matched.some(record => record.meta.requireAuth)) {
    console.log('需要登录');
    if (localStorage.is_login) { // 判断当前的token是否存在 ； 登录存入的token
      next();
    } else {
      next({
        path: '/login',
        query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next();
  }
});

export default router
